'use strict';
const routeParams = new URLSearchParams(location.search);
const fromGiftMeta = ['meta','facebook','instagram'].includes((routeParams.get('utm_source')||'').toLowerCase()) && (routeParams.get('utm_medium')||'').toLowerCase()==='paid_social' && routeParams.get('utm_campaign')==='tokutouseki_gift_202609';
document.querySelectorAll('a[data-line]').forEach(link => {
  link.href = fromGiftMeta ? "https://lin.ee/ukZ2Wct" : "https://lin.ee/st27VeI";
  link.dataset.lineRoute = "dedicated";
  link.dataset.trafficSegment = fromGiftMeta ? 'gift_meta' : 'gift_other';
});

const assetURL = name => window.__giftAssets?.[name] || 'assets/' + name;
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const focusOrigins = new WeakMap();
const menuToggle = document.querySelector('.menu-toggle');
function openDialog(dialog, trigger) {
  focusOrigins.set(dialog, trigger);
  dialog.showModal();
  document.body.classList.add('modal-open');
}
document.querySelectorAll('dialog').forEach(dialog => {
  dialog.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => {
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
    menuToggle.setAttribute('aria-expanded', 'false');
    focusOrigins.get(dialog)?.focus({preventScroll:true});
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
});
const menu = document.querySelector('#menu-dialog');
menuToggle.addEventListener('click', () => { menuToggle.setAttribute('aria-expanded','true'); openDialog(menu, menuToggle); });
menu.querySelectorAll('nav a').forEach(link => link.addEventListener('click', () => menu.close()));

const photoDialog = document.querySelector('#photo-dialog');
const photoStage = document.querySelector('.photo-stage');
const largePhoto = document.querySelector('#large-photo');
const zoomToggle = document.querySelector('#zoom-toggle');
function setZoom(enabled) {
  photoStage.classList.toggle('zoomed', enabled);
  zoomToggle.setAttribute('aria-pressed', String(enabled));
  zoomToggle.textContent = enabled ? '全体を表示' : 'さらに拡大';
  photoStage.scrollTop = 0; photoStage.scrollLeft = 0;
  if (enabled && largePhoto.complete && largePhoto.naturalWidth) centerPhoto();
}
function centerPhoto() {
  if (!photoStage.classList.contains('zoomed')) return;
  requestAnimationFrame(() => {
    photoStage.scrollLeft = Math.max(0, (largePhoto.clientWidth - photoStage.clientWidth) / 2);
    photoStage.scrollTop = Math.max(0, largePhoto.clientHeight * .59 - photoStage.clientHeight / 2);
  });
}
largePhoto.addEventListener('load', centerPhoto);
document.querySelectorAll('[data-photo]').forEach(button => button.addEventListener('click', () => {
  largePhoto.src = assetURL(button.dataset.photo);
  largePhoto.alt = button.querySelector('img').alt;
  document.querySelector('#photo-title').textContent = button.dataset.title || '写真の拡大';
  openDialog(photoDialog, button); setZoom(true);
}));
zoomToggle.addEventListener('click', () => setZoom(!photoStage.classList.contains('zoomed')));
largePhoto.addEventListener('click', () => setZoom(!photoStage.classList.contains('zoomed')));
document.querySelector('[data-report]').addEventListener('click', event => openDialog(document.querySelector('#report-dialog'), event.currentTarget));

const colors = {
 grey:{file:'plain.jpg',label:'ライトグレー',number:'LIGHT GREY / ライトグレー',caption:'ライトグレー｜やわらかな無地を、きみに。',alt:'ライトグレーの無地マットに座るクリーム色の犬'},
 pattern:{file:'overhead.jpg',label:'グレーバンビ',number:'GREY BAMBI / グレーバンビ',caption:'見上げる顔に、似合う柄。',alt:'グレーバンビマットから見上げるクリーム色の犬'},
 bambi:{file:'gold.jpg',label:'バンビ',number:'BAMBI / バンビ',caption:'ぬくもりを感じる、色と柄。',alt:'バンビマットに座る茶色い垂れ耳の犬'},
 pair:{file:'pair.jpg',label:'オフとブラウン',number:'OFF & BROWN / オフ・ブラウン',caption:'オフとブラウン、それぞれの一枚。',alt:'白とブラウンの別々のマットを一部重ねて置いた写真'}
};
const tabs = [...document.querySelectorAll('[data-color]')];
function selectColor(tab) {
  const color = colors[tab.dataset.color];
  tabs.forEach(t => { const selected = t === tab; t.setAttribute('aria-selected', String(selected)); t.tabIndex = selected ? 0 : -1; });
  document.querySelector('#color-panel').setAttribute('aria-labelledby', tab.id);
  const image = document.querySelector('#color-image'); image.src = assetURL(color.file); image.alt = color.alt;
  const photo = document.querySelector('#color-photo'); photo.dataset.photo = color.file; photo.dataset.title = color.caption;
  photo.setAttribute('aria-label', '選択した' + color.label + 'の写真を拡大');
  document.querySelector('#color-caption>span').textContent = color.number;
  document.querySelector('#color-caption>strong').textContent = color.caption;
}
tabs.forEach((tab, index) => {
  tab.addEventListener('click', () => selectColor(tab));
  tab.addEventListener('keydown', event => {
    let next;
    if (['ArrowRight','ArrowDown'].includes(event.key)) next = (index + 1) % tabs.length;
    else if (['ArrowLeft','ArrowUp'].includes(event.key)) next = (index - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else return;
    event.preventDefault(); selectColor(tabs[next]); tabs[next].focus({preventScroll:true});
  });
});

document.querySelectorAll('.photo-track').forEach(track => track.addEventListener('keydown', event => {
  if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
  event.preventDefault();
  track.scrollBy({left: track.clientWidth * (event.key === 'ArrowRight' ? 1 : -1), behavior: reducedMotion.matches ? 'instant' : 'smooth'});
}));
const heroTrack = document.querySelector('.hero-track');
let countFrame = 0;
heroTrack.addEventListener('scroll', () => {
  if (countFrame) return;
  countFrame = requestAnimationFrame(() => {
    const current = Math.min(8, Math.max(1, Math.round(heroTrack.scrollLeft / heroTrack.clientWidth) + 1));
    document.querySelector('.photo-count').innerHTML = String(current).padStart(2,'0') + ' <i>/</i> 08';
    countFrame = 0;
  });
}, {passive:true});

const sticky = document.querySelector('.sticky-line');
const inlineCTA = [...document.querySelectorAll('a[data-line]')].filter(link => !link.closest('.sticky-line'));
let stickyFrame = 0;
function refreshSticky() {
  const anyInlineVisible = inlineCTA.some(link => { const r = link.getBoundingClientRect(); return r.top >= 0 && r.bottom <= innerHeight; });
  const nearTop = window.scrollY < 120;
  sticky.hidden = nearTop || anyInlineVisible;
  sticky.inert = sticky.hidden;
  stickyFrame = 0;
}
function scheduleSticky() { if (!stickyFrame) stickyFrame = requestAnimationFrame(refreshSticky); }
addEventListener('scroll', scheduleSticky, {passive:true});
addEventListener('resize', scheduleSticky);
document.addEventListener('toggle', scheduleSticky, true);
if ('ResizeObserver' in window) new ResizeObserver(scheduleSticky).observe(document.querySelector('main'));
refreshSticky();
